import { Checkbox, MenuItem, Select, TextField } from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import React from "react";
import DateFnsUtils from "@date-io/date-fns";
const YES = "Yes";
const NO = "No";
const AutoField = ({
  field,
  value,
  onChange,
  style,
  error,
  disabled,
  investorType,
  ...props
}) => {
  const commonProps = {
    value,
    onChange,
    disabled,
    id: `${field.key}Field`,
    name: field.name || field.key,
    errorMessage: error,
    variant: "outlined",
    size: "small",
    onBlur: props.onBlur,
  };

  if (["number", "email", "password"].includes(field.type)) {
    commonProps.type = field.type;
  }
  if (field.type === "countrycode") {
    commonProps.onKeyDown = (e) => {
      const keys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "+"];
      if (isNaN(e.key) && !keys.includes(e.key)) {
        e.preventDefault();
      }
    };
  }

  let inputField;

  switch (field.type) {
    case "select":
      const optionsList =
        typeof field.options === "function"
          ? field.options(field.key)
          : field.options;
      inputField = (
        <>
          <Select
            placeholder={`Select ${field.name}`}
            {...commonProps}
            SelectDisplayProps={{
              style: {
                padding: "10px 12px",
              },
            }}
            displayEmpty
          >
            <MenuItem value={""} disabled>
              Select One
            </MenuItem>
            {optionsList.map((option, index) => (
              <MenuItem value={option.value} key={index}>
                {option.name || option.label}
              </MenuItem>
            ))}
          </Select>
        </>
      );

      break;

    case "date":
      inputField = (
        <>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              InputProps={{ readOnly: true }}
              required={true}
              disableFuture={true}
              emptyLabel="Select Date"
              format="dd/MM/yyyy"
              minDate={
                investorType === "minor"
                  ? new Date().setFullYear(new Date().getFullYear() - 18)
                  : new Date().setFullYear(1900)
              }
              maxDate={
                investorType === "minor"
                  ? new Date()
                  : new Date().setFullYear(new Date().getFullYear() - 18)
              }
              inputVariant="outlined"
              {...commonProps}
              onBlur={null}
              value={value || null}
            />
          </MuiPickersUtilsProvider>
        </>
      );
      break;

    case "choice":
      inputField = <ChoiceField {...commonProps} />;

      break;

    default:
      inputField = (
        <TextField
          // image="/images/investor.png"
          {...commonProps}
          inputProps={{
            autoComplete: "new-password",
          }}
        />
      );
  }

  return (
    <div
      className="d-flex flex-column input-margin-investor-flow appbar-div-investor-flow dual-margin-investor-flow"
      style={{ ...field.divStyle, ...style }}
    >
      <p
        className="mb-2"
        style={{ fontWeight: "500", whiteSpace: "nowrap", overflow: "hidden" }}
      >
        {field.name} {field.isRequired ? "*" : ""}
      </p>
      {inputField}

      {!!error && (
        <p className="mt-2 mb-0" style={{ fontSize: "0.9em", color: "red" }}>
          {error}
        </p>
      )}
    </div>
  );
};

const defaultChoiceOptions = [
  { name: "Yes", value: YES },
  { name: "No", value: NO },
];

export const ChoiceField = ({
  value,
  onChange,
  options = defaultChoiceOptions,
  disabled,
}) => {
  return (
    <div className="d-flex align-items-center ">
      {options.map((o) => (
        <div className={`d-flex align-items-center `}>
          <Checkbox
            checked={o.value === value}
            disabled={disabled}
            onClick={() => {
              const newValue = o.value;
              onChange({ target: { value: newValue } });
            }}
          />
          <p style={{}} className={`m-0`}>
            {o.name}
          </p>
        </div>
      ))}
    </div>
  );
};

export default AutoField;
